import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch } from "@/stores/hook";
import { setCurrentLeadId } from "@/features/leads/stores/leadFunctionalSlice";

/**
 * Opens a lead's detail sheet from anywhere.
 *
 * The lead drawer is driven by Redux (`currentLeadId`), NOT by a route param —
 * navigating to `/leads` alone would land on the list with nothing open (the
 * shareable `/leads?lead=<id>` link is LeadsPage reading that param and doing
 * this same dispatch). Mirrors `NotificationItem.navigateToEntity`,
 * including its deferral: opening inside the same click gesture lets the tail of
 * that gesture hit the Radix overlay, which closes the sheet again (visible flicker).
 */
export function useOpenLead() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(
    (leadId: number) => {
      if (!Number.isFinite(leadId)) return;
      window.setTimeout(() => {
        dispatch(setCurrentLeadId(leadId));
        if (!location.pathname.startsWith("/leads")) navigate("/leads");
      }, 16);
    },
    [dispatch, navigate, location.pathname],
  );
}
